import * as Accordion from '@radix-ui/react-accordion';

import { StyledParagraph } from '@/components/LimitOrders/utils';

import { ChevronDownIcon } from '@/ui/Icons/ChevronDownIcon';

import { classNames } from '@/utils/classnames';

import styles from './styles.module.css';

export function AccordionItem({
  title,
  subtitle,
  idx,
  open,
  itemsLength,
}: {
  title: string;
  subtitle: string;
  idx: number;
  open: string;
  itemsLength: number;
}) {
  const isOpen = open === title;
  const isLastItem = idx === itemsLength - 1;

  return (
    <Accordion.Item
      className={classNames(
        'py-4 pr-4 tablet:w-[438px] desktop:w-full desktop:max-w-[504px]',
        !isOpen
          ? 'opacity-30 transition-opacity duration-300 ease-in-out hover:opacity-60 active:opacity-80'
          : undefined,
      )}
      value={title}
    >
      <Accordion.Header>
        <Accordion.Trigger className="text-500 bg-transparent border-none flex px-0 w-full text-left">
          <span
            className={classNames(
              'bg-token-gray-400 p-2 rounded-xs h-6 flex justify-center items-center font-semibold mr-4 relative text-400 text-token-gray-800 opacity-100',
              ...(isOpen && !isLastItem
                ? [
                    'after:content-[""] after:absolute after:w-px after:h-15 after:bg-[linear-gradient(180deg,_#B9B9B9_-17.78%,rgba(130,130,130,0.00)_135.56%)] after:top-6',
                    styles.gradient,
                  ]
                : []),
            )}
          >
            {idx + 1}
          </span>
          <StyledParagraph className="text-500 bg-transparent border-none flex px-0 w-full items-center text-left">
            {title}
          </StyledParagraph>
          <ChevronDownIcon
            height={20}
            width={20}
            className={classNames(
              'ml-2 my-0.5 transition-transform duration-300',
              isOpen ? 'transform rotate-180' : undefined,
            )}
            aria-hidden
          />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="block mt-3 text-token-gray-700 ml-10">
        {subtitle}
      </Accordion.Content>
    </Accordion.Item>
  );
}
